import axios from "axios";

import { internalPageError } from "./internalPageError";
import type { NestedUserFavorite } from "~/src/types";

export const favoriteObject = async ({
  objectType,
  objectId,
  allFavorites,
  remove = false,
}: {
  objectType: string;
  objectId: string;
  allFavorites?:
    | string[]
    | {
        object_id: string;
        object_type: string;
      }[];

  remove?: boolean;
}): Promise<NestedUserFavorite | undefined> => {
  if (allFavorites) {
    if (
      allFavorites.some(
        (o) =>
          o === objectId || (typeof o === "object" && o.object_id === objectId),
      )
    ) {
      remove = true;
    }
  }

  if (remove) {
    await axios
      .post("/favorites/favorites/remove", {
        object_type: objectType,
        object_id: objectId,
      })
      .catch((err) => {
        internalPageError("Could not unfavorite object");
        console.error("Could not unfavorite object", err);
      });

    return undefined;
  } else {
    const res = await axios
      .post("/favorites/favorites", {
        object_type: objectType,
        object_id: objectId,
      })
      .then((res) => res.data.result as NestedUserFavorite)
      .catch((err) => {
        internalPageError("Could not favorite object");
        console.error("Could not favorite object", err);
        return undefined;
      });

    return res;
  }
};

export const refreshFavoriteData = <
  T extends { uuid?: string; user_favorite?: NestedUserFavorite },
  D extends { results: T[] },
>(
  favoriteObj: { id: string; updatedFavorite?: NestedUserFavorite },
  data: D,
  setData: (data: D) => void,
) => {
  setData({
    ...data,
    results: data.results.map((item) =>
      item.uuid === favoriteObj.id
        ? {
            ...item,
            user_favorite: favoriteObj.updatedFavorite,
          }
        : item,
    ),
  } as D);
};
